export class Seller {
  id?: string;
  email: string;
  firstName: string;
  lastName: string;
  address: string;
  phone: string;
  fullname?: string;

  constructor(seller?) {
    if (seller.id) { this.id = seller.id; }
    this.email = seller.email;
    this.firstName = seller.firstName;
    this.lastName = seller.lastName;
    this.address = seller.address;
    this.phone = seller.phone;
    if (seller.firstName && seller.lastName) { this.fullname = `${seller.firstName} ${seller.lastName}`; }
  }
}
